module.exports = __webpack_public_path__ + "static/12-aff07d33e49e6e2f587e2d327d1483fa.jpg";